"use client";

import { RotatingText } from "@oreme/ui";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import {
  BlurryEffect,
  DrawingLandscapeSky,
  DrawingLandscapeGround,
} from "@/components";

function HomeSectionHero(): ReactElement | null {
  const t = useTranslations("home.SectionHero");

  return (
    <header className="relative animate__animated animate__fadeIn">
      <div className="max-w-7xl mx-auto py-28 flex justify-center">
        <div className="relative z-30 flex flex-col gap-8 items-center text-center w-full px-8 min-w-0">
          <span className="text-xs rounded-full bg-foreground text-background px-3 py-1 leading-tight">
            {t("overline")}
          </span>
          <h1 className="text-4xl md:text-6xl max-w-3xl font-extrabold animate__animated animate__fadeInUp">
            {t("title")}
          </h1>
          <div className="flex flex-col items-center">
            <p className="text-base md:w-2/3 md:text-lg animate__animated animate__fadeInDown opacity-75">
              {t("lead")}
            </p>
            <RotatingText
              className="text-foreground font-semibold text-2xl"
              text={t.raw("rotate")}
              duration={1500}
              transition={{ duration: 0.3, ease: "easeOut" }}
            />
          </div>
        </div>
      </div>
      <figure className="absolute z-10 inset-0">
        <BlurryEffect />
      </figure>
      <figure className="absolute inset-x-0 top-0 w-full h-full overflow-hidden">
        <DrawingLandscapeSky className="w-full h-full block" />
      </figure>
      <figure className="absolute inset-x-0 bottom-0 w-full h-full overflow-hidden">
        <DrawingLandscapeGround className="w-full h-full block" />
      </figure>
    </header>
  );
}

export { HomeSectionHero };
